import React from "react"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { useTranslation } from "react-i18next"
import { formatCurrencyAmount } from "utils/currency"

const CODSettlementCard = ({ codData = {}, onSettle, loading, canSettle = true }) => {
  const { t } = useTranslation()
  const {
    totalCollected = 0,
    amountSettled = 0,
    outstandingAmount = 0,
    pendingOrders = 0,
  } = codData

  return (
    <Card className="shadow-sm">
      <CardBody>
        <h6 className="text-uppercase fw-semibold mb-3">{t("COD Settlement")}</h6>
        <Row className="g-3 mb-3">
          <Col xs={6}>
            <div className="border rounded p-3 text-center">
              <p className="text-muted small mb-1">{t("Total Collected")}</p>
              <h5 className="mb-0 text-dark">
                {formatCurrencyAmount(totalCollected)}
              </h5>
            </div>
          </Col>
          <Col xs={6}>
            <div className="border rounded p-3 text-center">
              <p className="text-muted small mb-1">{t("Amount Settled")}</p>
              <h5 className="mb-0 text-success">
                {formatCurrencyAmount(amountSettled)}
              </h5>
            </div>
          </Col>
          <Col xs={6}>
            <div className="border rounded p-3 text-center">
              <p className="text-muted small mb-1">{t("Outstanding")}</p>
              <h5 className="mb-0 text-danger">
                {formatCurrencyAmount(outstandingAmount)}
              </h5>
            </div>
          </Col>
          <Col xs={6}>
            <div className="border rounded p-3 text-center">
              <p className="text-muted small mb-1">{t("Pending Orders")}</p>
              <h5 className="mb-0 text-warning">{pendingOrders}</h5>
            </div>
          </Col>
        </Row>
        {canSettle ? (
          <Button
            color="primary"
            block
            onClick={onSettle}
            disabled={loading || outstandingAmount <= 0}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-1" />
                {t("Processing...")}
              </>
            ) : (
              <>
                <i className="bx bx-money me-1"></i>{t("Settle COD")}
              </>
            )}
          </Button>
        ) : null}
      </CardBody>
    </Card>
  )
}

export default CODSettlementCard
